import React, { FC, useEffect, useState } from "react";
import { PDFViewer, PDFViewerTool } from "@progress/kendo-react-pdf-viewer";
import { useParams, useSearchParams  } from "react-router";
import {
	getWeeklyTurnoverReportApi
} from "api/pdf";
import { PickListFilter } from "api/pickList";
import { useInfoStore } from "store/error";
import { Loader } from "@progress/kendo-react-indicators";

const tools: PDFViewerTool[] = [
	"pager",
	"spacer",
	"zoomInOut",
	"zoom",
	"selection",
	"spacer",
	"search",
	//"open",
	"download",
	"print",
];

export const WeeklyTurnoverPdfViewer: FC<{}> = ({ }) => {
	const { id, type, guid } = useParams();
	const [pdfData, setPdfData] = useState<string>();
	const [loading, setLoading] = useState<boolean>(false);
	const { setError } = useInfoStore();
	const [filterOptions, setFilterOptions] = useState<PickListFilter>({
		take: 10000,
		skip: 0,
	});

	const [searchParams] = useSearchParams();
	const searchYear = searchParams.get('year'); 

	useEffect(() => {
		console.log("params: ", searchYear);

		setLoading(true);

		let year = parseInt(searchYear ?? "2021");

		getWeeklyTurnoverReportApi({ ...filterOptions, year: year })
			.then((response) => {
				setPdfData(response);
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	if (loading) {
		return (
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
				<Loader size="large" type="converging-spinner" />
			</div>
		);
	}

	return <PDFViewer data={pdfData} style={{ height: "100%" }} tools={tools} />;
};

export default WeeklyTurnoverPdfViewer;